import React, { useState } from "react";
import { Plus, Save, Trash2 } from "lucide-react";
import { api } from "./api";
import { useConfirmation } from "./Confirmation";
import { BoutonSombre, Case, Eyebrow, Section } from "./ui";

/* Pass illimités (Infinity, Golden) : prix et conditions, repris du site. Un élève dont
   la « Formule » est un pass paie le pass et non ses cours ; la réduction d'accumulation
   ne s'y ajoute pas. Le Golden Pass ne couvre ni la compétition ni la compagnie. */
export function PassIllimites({ valeurs, onEnregistre }) {
  const { informer } = useConfirmation();
  const [liste, setListe] = useState(valeurs.pass || []);
  const [occupe, setOccupe] = useState(false);
  const [err, setErr] = useState("");

  const maj = (i, champ, valeur) => setListe(liste.map((p, k) => (k === i ? { ...p, [champ]: valeur } : p)));

  const enregistrer = async () => {
    setOccupe(true);
    setErr("");
    try {
      await api("/reglages", { method: "PATCH", body: JSON.stringify({ valeurs: { pass: liste } }) });
      await onEnregistre();
      await informer({ titre: "Pass enregistrés", ton: "succes",
        texte: "Le moteur de tarif applique ces prix aux élèves dont la formule est un pass." });
    } catch (e) { setErr(e.message); }
    setOccupe(false);
  };

  return (
    <Section titre="Pass illimités" testid="reglages-pass"
      aide="Prix et conditions des pass, tels que le site les annonce. La console les applique : l'élève paie son pass, ses cours couverts passent à 0 et la réduction d'accumulation ne s'ajoute pas."
      action={
        <BoutonSombre onClick={enregistrer} disabled={occupe} testid="pass-enregistrer">
          <Save size={14} /> Enregistrer
        </BoutonSombre>
      }>
      {err && <p className="text-sm" style={{ color: "#B91C1C" }}>{err}</p>}
      <div className="space-y-3">
        {liste.map((p, i) => (
          <div key={p.id || i} className="bg-white rounded-2xl border p-4 grid md:grid-cols-4 gap-3"
            style={{ borderColor: "var(--border)" }} data-testid={`pass-${i}`}>
            <label className="block">
              <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[var(--muted)]">Nom du pass</span>
              <input className="input-field mt-1" value={p.label || ""}
                onChange={(e) => maj(i, "label", e.target.value)} data-testid={`pass-label-${i}`} />
              <span className="block text-[11px] text-[var(--muted)] mt-1">
                Doit être écrit comme dans la colonne « Formule » du formulaire.
              </span>
            </label>
            <label className="block">
              <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[var(--muted)]">Prix du semestre CHF</span>
              <input className="input-field mt-1" type="number" value={p.prix || 0}
                onChange={(e) => maj(i, "prix", Number(e.target.value || 0))} data-testid={`pass-prix-${i}`} />
            </label>
            <div>
              <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[var(--muted)]">Compétition</span>
              <span className="flex items-center gap-2 mt-2 text-sm cursor-pointer select-none"
                onClick={() => maj(i, "couvre_competition", !p.couvre_competition)}
                data-testid={`pass-competition-${i}`}>
                <Case cochee={!!p.couvre_competition} onChange={(v) => maj(i, "couvre_competition", v)}
                  testid={`pass-competition-case-${i}`} />
                Compétition et compagnie comprises
              </span>
              <span className="block text-[11px] text-[var(--muted)] mt-1">
                Décoché : ces cours restent facturés en plus du pass.
              </span>
            </div>
            <label className="block">
              <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[var(--muted)]">Public</span>
              <input className="input-field mt-1" value={p.public || ""}
                onChange={(e) => maj(i, "public", e.target.value)} data-testid={`pass-public-${i}`} />
            </label>
            <label className="md:col-span-4 block">
              <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[var(--muted)]">Conditions (texte du site)</span>
              <textarea className="input-field mt-1" rows={2} value={p.conditions || ""}
                onChange={(e) => maj(i, "conditions", e.target.value)} data-testid={`pass-conditions-${i}`} />
            </label>
            <div className="md:col-span-4 flex items-center gap-3">
              <span className="text-xs text-[var(--muted)]">Identifiant : {p.id || "à créer"}</span>
              <button className="btn-ghost ml-auto" onClick={() => setListe(liste.filter((_, k) => k !== i))}
                data-testid={`pass-supprimer-${i}`}>
                <Trash2 size={13} /> Retirer
              </button>
            </div>
          </div>
        ))}
      </div>
      <button className="btn-ghost" data-testid="pass-ajouter"
        onClick={() => setListe([...liste, { id: `pass_${Date.now()}`, label: "", prix: 0, public: "enfant", couvre_competition: false, conditions: "" }])}>
        <Plus size={13} /> Ajouter un pass
      </button>
    </Section>
  );
}
